import {useContext} from "react";
import {SaleContext} from "providers/SaleProvider/SaleContext";
export const useSaleInformation = () => {
	return useContext(SaleContext)
}
